import { cx } from '../lib/cx';

export interface DateTileProps {
  /** Day of month, e.g. "24". */
  day: string;
  /** Short month, e.g. "Jul". */
  month: string;
  tone?: 'neutral' | 'primary' | 'warning' | 'danger';
  size?: 'sm' | 'md';
  /** Full date for screen readers, e.g. "24 July 2026". */
  label?: string;
  className?: string;
}

/** Stacked day-over-month tile used by appointment history, closed dates and
 *  date overrides (brief §7.7/§7.8) — a calendar page in 44×44. */
export function DateTile({ day, month, tone = 'neutral', size = 'md', label, className }: DateTileProps) {
  return (
    <span
      className={cx('tc-datetile', tone !== 'neutral' && `tc-datetile--${tone}`, size === 'sm' && 'tc-datetile--sm', className)}
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <span className="tc-datetile__day">{day}</span>
      <span className="tc-datetile__month">{month}</span>
    </span>
  );
}
